import React, { useState } from 'react';
import ProductForm from './ProductForm';
import sunflower from './imgs/sunflower.png';

const AddProductPage = ({ setProducts, products }) => {
  const [added, setAdded] = useState(false);
  const handleAddProduct = (form, imagePreview) => {
    const newProduct = {
      id: products.length + 1,
      name: form.name,
      price: Number(form.price),
      description: form.description,
      category: form.category,
      image: imagePreview || sunflower
    };
    setProducts([newProduct, ...products]);
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <div style={{minHeight: '75vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', paddingTop: '4rem'}}>
      <div style={{width: '100%', maxWidth: 500}}>
        <ProductForm onAddProduct={handleAddProduct} />
        {added && <div style={{textAlign: 'center', color: '#5c4033', marginTop: '1rem'}}>Product added!</div>}
      </div>
    </div>
  );
};

export default AddProductPage;
